import { AddBankAccountTask } from '../../common/tasks/AddBankAccountTask';
import { ServiceRequestSendEmailCardTask } from '../../common/tasks/ServiceRequestSendEmailCardTask';
import { ApproveCompanyDetails } from '../components/ApproveCompanyDetails';
import { MarkDSCFilingComplete } from '../components/director-procurement/MarkDSCFiling';
import { MarkDSCReceived } from '../components/director-procurement/MarkDSCReceived';
import { MarkDirectorMeetingCompleteTask } from '../components/director-procurement/MarkMeetingComplete';
import { ScheduleMeetingTask } from '../components/director-procurement/ScheduleMeetingTask';
import { FillCompanyDetails } from '../components/FillCompanyDetails';
import { CertOfIncorporationUploadTask } from '../components/incorporation-filings/CertOfIncorpUploadTask';
import { IncorporationDocumentPreparationTask } from '../components/incorporation-filings/DocumentPreparation';
import { FilingSubmittedToMCATask } from '../components/incorporation-filings/FilingSubmittedToMCA';
import { PanDocumentUploadTask } from '../components/incorporation-filings/PanDocumentUploadTask';
import { TanDocumentUploadTask } from '../components/incorporation-filings/TanDocumentUploadTask';
import { AoaDocumentUploadTask } from '../components/incorporation-filings/AoaDocumentUploadTask';
import { MoaDocumentUploadTask } from '../components/incorporation-filings/MoaDocumentUploadTask';
import { IncorpSignedDocumentUploadTask } from '../components/incorporation-filings/UploadSignedDocument';
import { MarkLLPDeedFilingTask } from '../components/llp-deed-filing/MarkLLPDeedFilingTask';
import { SourceStampPaperTask } from '../components/llp-deed-filing/SourceStampPaper';
import { UploadApprovedLLPDeedTask } from '../components/llp-deed-filing/UploadApprovedLLPDeedTask';
import { UploadUnsignedLLPDeedTask } from '../components/llp-deed-filing/UploadUnsignedLLPDeed';
import { FillNameReservationDetails } from '../components/name-reservation/FillNameReservationDetails';
import { UploadNameDocumentDetails } from '../components/name-reservation/UploadNameDocumentDetails';
import { IndDirectorTasks } from '../ind-directors';
import { IndLLPIncorporationTasks } from './ind-llp';

export const IND_LLP_INCORPORATION_COMPONENT_MAP = {
  [IndLLPIncorporationTasks.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [IndLLPIncorporationTasks.REVIEW_CORPORATION_DETAILS]: ApproveCompanyDetails,
  [IndLLPIncorporationTasks.COMPLETE_MCA_NAME_RESERVATION]:
    FillNameReservationDetails,
  [IndLLPIncorporationTasks.UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION]:
    UploadNameDocumentDetails,
  [IndLLPIncorporationTasks.SEND_EMAIL_UPDATE]: ServiceRequestSendEmailCardTask,

  // Incorporation Filings

  [IndLLPIncorporationTasks.INCORPORATION_DOCUMENT_PREPARATION]:
    IncorporationDocumentPreparationTask,
  [IndLLPIncorporationTasks.CLIENT_UPLOAD_SIGNED_DOCUMENT]:
    IncorpSignedDocumentUploadTask,
  [IndLLPIncorporationTasks.FILING_SUBMITTED_TO_MCA]: FilingSubmittedToMCATask,
  [IndLLPIncorporationTasks.CLIENT_UPLOAD_CERT_OF_INCORP]:
    CertOfIncorporationUploadTask,
  [IndLLPIncorporationTasks.CLIENT_UPLOAD_PAN]: PanDocumentUploadTask,
  [IndLLPIncorporationTasks.CLIENT_UPLOAD_TAN]: TanDocumentUploadTask,
  [IndLLPIncorporationTasks.AGENT_UPLOAD_AOA]: AoaDocumentUploadTask,
  [IndLLPIncorporationTasks.AGENT_UPLOAD_MOA]: MoaDocumentUploadTask,

  // Bank Account Creation

  [IndLLPIncorporationTasks.CLIENT_ADD_BANK_ACCOUNT]: AddBankAccountTask,

  // LLP Deed Filing
  [IndLLPIncorporationTasks.SOURCING_STAMP_PAPER]: SourceStampPaperTask,
  [IndLLPIncorporationTasks.UPLOAD_LLP_DEED]: UploadUnsignedLLPDeedTask,
  [IndLLPIncorporationTasks.LLP_DEED_FILING_SUBMITTED]: MarkLLPDeedFilingTask,
  [IndLLPIncorporationTasks.UPLOAD_SIGNED_LLP_DEED]: UploadApprovedLLPDeedTask,

  // DSC Procurement
  [IndDirectorTasks.SCHEDULE_MEET_WITH_DSC_AGENT]: ScheduleMeetingTask,
  [IndDirectorTasks.MARK_MEETING_COMPLETE]: MarkDirectorMeetingCompleteTask,
  [IndDirectorTasks.MARK_DSC_FILING]: MarkDSCFilingComplete,
  [IndDirectorTasks.MARK_DSC_RECEIVED]: MarkDSCReceived,
};
